<template>
  <div class="views-index" :style="{ '--carouselHeight': carouselHeight }">
    <!-- 首页banner -->
    <div
      class="top-banner"
      @mouseenter="next_btn = true"
      @mouseleave="next_btn = false"
    >
      <el-carousel
        ref="myCarousel"
        class="top-banner-carousel"
        arrow="never"
        trigger="click"
        :height="carouselHeight"
        autoplay
        :interval="6000"
        :autoplay="false"
        indicator-position="none"
        @change="carouselChange"
      >
        <el-carousel-item
          v-for="(item, index) in topBannerList"
          :key="index"
          :label="topBannerListName[index]"
        >
          <div class="top-banner-video" v-if="index == 0">
            <video
              id="video1"
              style="width: 100%; object-fit: fill"
              :src="item.url"
              autoplay
              muted
              loop
            >
              <!-- poster="/static/images_20230306/首页/顶部封面.webp" -->
              您的浏览器不支持 video
            </video>
            <!-- <div class="tip">构建世界的时空基础</div> -->
          </div>
          <div class="top-banner-picture" @click="gotoProduct(item)" v-else>
            <img :src="item.url" alt="" width="100%" height="100%" />
            <!-- <div v-if="index == 1" class="one_lbt_item_3">
              <div class="one_lbt_item_60" :class="{ active: active1 > 0 }" style="text-align: left">
                <img src="/static/images_20230306/title/farm_title.webp" alt />
              </div>
              <div class="one_lbt_item_40" style="text-align: left" :class="{ active: active1 > 1 }">
                实景三维数据中心解决方案
              </div>
              <router-link to="/cn/nongchang">
                <div class="picture-title-link farm-color" :class="{ active: active1 > 2 }">
                  进一步了解
                </div>
              </router-link>
            </div>
            <div v-if="index == 2" class="picture-title">
              <div class="picture-title-img" :class="{ active: active1 > 0 }" style="text-align: left">
                <img src="/static/images_20230306/title/master_title.webp" alt />
              </div>
              <div class="picture-title-name" style="text-align: center" :class="{ active: active1 > 1 }">
                超大规模实景三维集群建模软件
              </div>
              <router-link to="/cn/gcluster">
                <div class="picture-title-link" :class="{ active: active1 > 2 }">
                  进一步了解
                </div>
              </router-link>
            </div>
            <div v-if="index == 3" class="one_lbt_item_3">
              <div class="one_lbt_item_60" :class="{ active: active1 > 0 }" style="text-align: left">
                <img src="/static/images_20230306/title/earth_title.webp" alt />
              </div>
              <div class="one_lbt_item_40 font-color" style="text-align: left;" :class="{ active: active1 > 1 }">
                简单实用的实景三维云平台
              </div>
              <a href="https://get3d.cn/" class="picture-title-link earth-color"
                :class="{ active: active1 > 2 }">
                进一步了解
              </a>
            </div>
            <div v-if="index == 4">
              <div class="museum_tip">
                用科技传承文明
              </div>
            </div> -->
            <div class="picture-content" v-if="item.title">
              <div class="picture-header">{{ item.title }}</div>
              <div>
                <span class="picture-desc">{{ item.desc }}</span>
                <span class="picture-link cp">{{ item.link }}</span>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div
        @click="toPrev"
        class="one_left_next one_next cp"
        :class="{ is_active_next: bannerBtnL }"
        @mouseenter="bannerBtnL = true"
        @mouseleave="bannerBtnL = false"
      >
        <img src="/static/images/one_left_next.webp" />
      </div>
      <div
        @click="toNext"
        class="one_right_next one_next cp"
        :class="{ is_active_next: bannerBtnR }"
        @mouseenter="bannerBtnR = true"
        @mouseleave="bannerBtnR = false"
      >
        <img src="/static/images/one_right_next.webp" />
      </div>
    </div>
    <!-- 成果 -->
    <div class="achieve-content">
      <div class="left-col" @click="windowOpen(morePaths[0])">
        <div class="left-header">
          <div class="header-title">全面升级！低空大师2.2.0版本震撼登场</div>
          <div class="header-desc">
            超20项创新功能与优化升级，全面满足多样化需求
          </div>
        </div>
        <img
          class="achieve-img"
          src="/static/images_20240311/news/1.jpg"
          alt=""
        />
        <!-- <div class="left-header-overlay"></div> -->
      </div>
      <div class="right-col">
        <div class="top-content" @click="windowOpen(morePaths[1])">
          <div class="top-header">
            <div class="header-title">
              效率实测+全链闭环
            </div>
            <div class="header-desc">
              重建农场信创版定义测绘信创新生态
            </div>
          </div>
          <img
            class="achieve-img"
            src="/static/images_20240311/news/2.jpg"
            alt=""
          />
          <!-- <div class="top-header-overlay"></div> -->
        </div>
        <div class="bottom-content">
          <div class="bottom-left" @click="windowOpen(morePaths[2])">
            <div class="bottom-left-header">
              <div class="header-title">
                青春无畏 未来可期
              </div>
              <div class="header-desc">
                大势智慧2025校招生的职场初章
              </div>
            </div>
            <img
              class="achieve-img"
              src="/static/images_20240311/news/3.jpg"
              alt=""
            />
            <!-- <div class="bottom-left-overlay"></div> -->
          </div>
          <div class="bottom-right" @click="windowOpen(morePaths[3])">
            <div class="bottom-right-header">
              <div class="header-title">
                入境武当 震撼首映
              </div>
              <div class="header-desc">
                全球首部超大型虚实共生VR山岳史诗
              </div>
            </div>
            <img
              class="achieve-img"
              src="/static/images_20240311/news/4.jpg"
              alt=""
            />
            <!-- <div class="bottom-right-overlay"></div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="news-dynamic">
      <div class="news-desc" @click="windowOpen(newsUrl)">
        <div class="back"></div>
        <div class="news-desc-container">
          <div class="news-desc-head">News</div>
          <div class="news-desc-content">新闻动态</div>
          <div class="news-more">了解更多 ></div>
        </div>
      </div>
      <div class="news-container">
        <div class="news-content" ref="newsRef">
          <div
            class="news-card"
            v-for="(item, index) in newsCards"
            :key="index"
            @click="gotoMore(item)"
          >
            <div
              class="news-card-img"
              :style="'background-image: url(' + item.url + ');'"
            ></div>
            <div class="news-card-desc">
              <div class="news-card-text">
                <div class="news-card-name">
                  <img src="/static/images_20230726/new/arrow.webp" alt="" />
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="news-btn news-left-btn" @click="newsToPrev">
          <img src="/static/images/one_left_next.webp" />
        </div>
        <div class="news-btn news-right-btn" @click="newsToNext">
          <img src="/static/images/one_right_next.webp" />
        </div> -->
      </div>
    </div>
    <!-- 产品 -->
    <div class="product-content">
      <div class="data_header">
        自主可控的AI三维生产全流程产品体系
      </div>
      <div class="data_desc">
        以AI感知三维建模能力为核心，构建全流程三维产品矩阵
      </div>
      <div class="row-content" style="padding-top: 40px;">
        <div class="row">
          <div class="card" @click="routerPush('/cn/skyCloud')">
            <img src="/static/images_20240909/1.jpg" />
            <div class="info">
              <div>低空云</div>
              <div>首个低空三维AI感知操作系统</div>
              <div @click="routerPush('/cn/skyCloud')">了解更多</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="card" @click="routerPush('/cn/gcluster')">
            <img src="/static/images_20240909/2.jpg" />
            <div class="info">
              <div>重建大师</div>
              <div>大规模实景三维集群建模软件</div>
              <div @click="routerPush('/cn/gcluster')">了解更多</div>
            </div>
          </div>
          <div class="card" @click="routerPush('/cn/nongchang')">
            <img src="/static/images_20240909/3.jpg" />
            <div class="info">
              <div>重建农场</div>
              <div>实景三维数据中心解决方案</div>
              <div @click="routerPush('/cn/nongchang')">了解更多</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="card" @click="routerPush('/cn/dasmesh')">
            <img src="/static/images_20240909/4.jpg" />
            <div class="info">
              <div>网格大师</div>
              <div>实景三维数据治理专家</div>
              <div @click="routerPush('/cn/dasmesh')">了解更多</div>
            </div>
          </div>
          <div class="card" @click="routerPush('/cn/mofang')">
            <img src="/static/images_20240909/5.jpg" />
            <div class="info">
              <div>模方</div>
              <div>实景三维的PhotoShop</div>
              <div @click="routerPush('/cn/mofang')">了解更多</div>
            </div>
          </div>
        </div>
        <div class="row sp">
          <div class="card" @click="routerPush('/cn/hawkeye')">
            <img src="/static/images_20240909/6.jpg" />
            <div class="info">
              <div>鹰眼</div>
              <div>实时建模一体化设备</div>
              <div @click="routerPush('/cn/hawkeye')">了解更多</div>
            </div>
          </div>
          <div class="card" @click="routerPush('/cn/wisdomR100')">
            <img src="/static/images_20240909/7.jpg" />
            <div class="info">
              <div>智影 R100</div>
              <div>可建模的全场景SLAM三维激光扫描仪</div>
              <div @click="routerPush('/cn/wisdomR100')">了解更多</div>
            </div>
          </div>
          <div class="card" @click="routerPush('/cn/wisdomS100')">
            <img src="/static/images_20240909/8.jpg" />
            <div class="info">
              <div>智影 S100</div>
              <div>可建模的轻巧手持SLAM三维激光扫描仪</div>
              <div @click="routerPush('/cn/wisdomS100')">了解更多</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="solve_plan">
      <div class="data_header">
        低空三维AI感知应用解决方案
      </div>
      <div class="data_desc">
        以空间AI智算能为核心，赋能低空场景应用
      </div>
      <!-- <div class="solve_content">
        <div class="solve_card" v-for="(item, index) in solveList" :key="index">
          <div
            class="text_content"
            :class="{ 'row-left': index % 2 == 0, 'row-right': index % 2 == 1 }"
          >
            <div class="solve_card_name">{{ item.name }}</div>
            <div class="solve_card_desc">{{ item.describe }}</div>
            <div class="solve_card_link" @click="$router.push(item.router)">
              {{ item.link }}
            </div>
          </div>
          <div
            class="solve_img"
            :style="
              'background-image: url(' +
                item.url +
                '); background-size: cover; background-position: center; width:930px; height:514px;margin:5px'
            "
          ></div>
        </div>
      </div> -->
      <div class="swiper-tabs">
        <div class="tabs-head" :style="{ '--moveX': `${-254 + tabsHeight}px` }">
          <div class="tabs-scroll"></div>
          <div
            class="tabs-head-item"
            v-for="(item, index) in tabsHeadList"
            :key="index"
            :class="{
              'tab-active': tabActive === index,
              'text-left': index == 2,
              'text-right': index == 0
            }"
            @click="selectTab(index)"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="swiper_content swiper_content2">
        <div
          class="swiper-container2"
          style="position: absolute;left: 51%;transform: translateX(-53%);width: 3600px;height: 720px"
        >
          <div class="swiper-wrapper" data-swiper-parallax="-1220">
            <div
              class="swiper-slide"
              v-for="(item, index) in programmeData"
              :key="index"
            >
              <div class="swiper_slide_img programme_box">
                <div
                  class="img"
                  :style="
                    'background-image: url(' +
                      item.bg +
                      '); background-size: cover; background-position: center; width:1200px; height:718px;'
                  "
                >
                  <div class="t1">
                    {{ item.v1 }}
                    <!-- 农房核查解决方案 -->
                  </div>
                  <div class="t2" :style="{ width: item.width + 'px' }">
                    <div v-for="(k, i) in item.v2" :key="i">
                      {{ k }}
                    </div>
                  </div>
                  <div class="t3" :data-id="item.id">
                    进一步了解 >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //按钮 -->
        <img
          src="/static/images_2023_5_18/4.svg"
          @click="slideChange2(1)"
          class="lbt_l cp"
        />
        <img
          src="/static/images_2023_5_18/5.svg"
          @click="slideChange2(2)"
          class="lbt_r cp"
        />
      </div>
    </div>
    <!-- 数据服务 -->
    <div class="data_container">
      <div class="data_header">
        实景三维数字底座建设
      </div>
      <div class="data_desc">
        自主化、安全化、标准化的一站式数据服务与应用
      </div>
      <div class="data_tab">
        <div
          class="tab_item cp"
          :class="{ tab_item_active: isActiveTab === 0 }"
          @click="setCarousel(0)"
        >
          地理场景
        </div>

        <div
          class="tab_item cp mid-tab-item"
          :class="{ tab_item_active: isActiveTab === 1 }"
          @click="setCarousel(1)"
        >
          地理实体
        </div>

        <div
          class="tab_item cp"
          :class="{ tab_item_active: isActiveTab === 2 }"
          @click="setCarousel(2)"
        >
          CIM
        </div>
      </div>
      <div class="swiper_content">
        <div
          class="swiper-container"
          style="position: absolute;left: 51%;transform: translateX(-53%);width: 3600px;height: 720px"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in dataImg"
              :key="index"
            >
              <div class="swiper_slide_img">
                <div
                  class="img"
                  :style="
                    'background-image: url(' +
                      item +
                      '); background-size: cover; background-position: center; width:1200px; height:720px;'
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
        <!-- //按钮 -->
        <div class="lbt_l cp" @click="slideChange(1)">
          <img src="/static/images_2023_5_18/4.svg" />
          <!-- <span style="font-size: 20px;color:#bababa;font-weight: 800" class="el-icon-arrow-left"></span> -->
        </div>
        <div class="lbt_r cp" @click="slideChange(2)">
          <img src="/static/images_2023_5_18/5.svg" />
          <!-- <span style="font-size: 20px;color:#bababa;font-weight: 800" class="el-icon-arrow-right"></span> -->
        </div>
      </div>
    </div>

    <!-- 智慧文博 -->
    <wisdomBanner></wisdomBanner>
    <!-- 云端地球 -->
    <div class="cloud_earth">
      <div class="earth_header">
        云端地球：低空三维云平台
      </div>
      <div class="earth_desc">
        人人可用的自动化三维建模与AI分析云平台
      </div>
      <div class="earth_btn">
        <el-button
          class="button"
          type="primary"
          size="mini"
          @click="addRebuild"
          style="width: 100px"
          >立即建模</el-button
        >
      </div>

      <!-- <div class="earth_content">
        <div class="earth_slide">
          <ul class="left_earth_swiper">
            <li v-for="(item, index) in leftEarthList" :key="index">
              <earthCard :imgData="item"></earthCard>
            </li>
          </ul>
          <ul class="right_earth_swiper">
            <li v-for="(item, index) in rightEarthList" :key="index">
              <earthCard :imgData="item"></earthCard>
            </li>
          </ul>
        </div>
      </div> -->
      <div class="card-box">
        <modelCart
          :key="item.id"
          v-for="(item, index) in filterEarthList"
          :style="{
            width: 100 / multiple + '%',
            marginTop: index < multiple ? '0' : '22px'
          }"
          :data="item"
          ref="modelcartRef"
          :loading="loading"
        />
      </div>
      <div class="earth_bottom">
        <div
          class="left-btn"
          :class="{ 'active-btn': activeSide === 0 }"
          @click="selectSide(0)"
        ></div>
        <div
          class="right-btn"
          :class="{ 'active-btn': activeSide === 1 }"
          @click="selectSide(1)"
        ></div>
      </div>
    </div>

    <div class="partner-contain">
      <div class="partner-title">合作伙伴</div>
      <img
        src="/static/images_20230306/首页/全球顶级合作伙伴.webp"
        alt=""
        :width="1200"
      />
    </div>
  </div>
</template>

<script>
import "@/assets/css/swiper.min.css";
import Swiper from "swiper";

import productCard from "@/components/productCard";
import wisdomBanner from "@/components/wisdomBanner";
import earthCard from "@/components/earthCard";
import modelCart from "@/components/modelCart";

import modelApi from "@/api/model";
import $ from "jquery";
export default {
  name: "views-about",
  components: {
    productCard,
    wisdomBanner,
    earthCard,
    modelCart
  },
  data() {
    return {
      programmeData: [
        {
          bg: "/static/images_2023_5_18/2.webp",
          v1: "自然资源监管",
          id: 1,
          v2: [
            "地上地下一体化三维信息技术，改造传统信息化流程与架构，提升信息化水平，为自然资源业务赋能。"
          ],
          v3: "farmhouse",
          width: 483,
          url: "/cn/nrs"
        },
        {
          bg: "/static/images_2023_5_18/3.webp",
          v1: "矿山监管",
          id: 3,
          v2: [
            "对矿山全生命周期的多源异构数据进行治理，支撑矿产资源监测-监管-处置全过程，提高矿产资源综合监管水平。"
          ],
          v3: "farmhouse",
          width: 525,
          url: "/cn/mine"
        },
        {
          bg: "/static/images_2023_5_18/1.webp",
          v1: "农房核查解决方案",
          id: 2,
          v2: [
            "借助新技术、新手段支撑农村宅基地和建房核查，加快对农村宅基地建设情况进行摸底核查，推进施工核查、验收审批进度，促进城乡高质量发展。"
          ],
          v3: "farmhouse",
          width: 609,
          url: "/cn/farmhouse"
        }
      ],
      //轮播图 左侧按钮 背景色
      bannerBtnL: false,
      //轮播图 右侧按钮 背景色
      bannerBtnR: false,
      topBannerList: [
        {
          url:
            "https://ds-rebuild-prod-1301434080.cos.ap-guangzhou.myqcloud.com/common/video/homesite/video/top.mp4"
        },
        {
          url: "/static/images_20230810/36.webp",
          path: "/cn/enterpriseCooperation" //企业合作页面
        },
        {
          url: "/static/images_20230726/banner/1.webp",
          title: "超大规模实景三维集群建模软件",
          desc: "重建大师6.1正式发布",
          link: "了解更多>",
          path: "/cn/gcluster"
        },
        {
          url: "/static/images_20230726/banner/2.webp",
          title: "语义三维模型全自动生产软件",
          desc: "三维有语义，机器可识别",
          link: "了解更多>",
          path: "/cn/gcluster"
        },
        {
          url: "/static/images_20230726/banner/6.webp",
          title: "国产化大规模自动化三维重建软件",
          desc: "自主可控的三维建模技术",
          link: "了解更多>",
          path: "/cn/gcluster"
        },
        {
          url: "/static/images_20230726/banner/5.webp",
          title: "领先的“空、天、地”一体化高精度三维重建技术",
          desc: "致力于文化遗产数字化保护，永久传承历史文明",
          link: "了解更多>",
          path: "/cn/wise"
        },
        {
          url: "/static/images_20230726/banner/3.webp",
          path: "/cn/nongchang"
        },
        {
          url: "/static/images_20230726/banner/4.webp",
          pathlink: "https://www.get3d.cn/"
        }
      ],
      topBannerListName: ["云端地球", "重建农场", "重建大师"],
      interval: null,
      active1: 0,
      productList: [
        {
          name: "重建农场",
          describe: "实景三维数据中心解决方案",
          link: "进一步了解>",
          url: "/static/images_20230306/首页/farm.webp",
          router: "/cn/nongchang"
        },
        {
          name: "重建大师",
          describe: "大规模实景三维集群建模软件",
          link: "进一步了解>",
          url: "/static/images_20230306/首页/master.webp",
          router: "/cn/gcluster"
        },
        {
          name: "DasViewer",
          describe: "市占率最高的实景三维极速浏览展示工具",
          link: "进一步了解>",
          url: "/static/images_20230306/首页/dasViewer.webp",
          router: "/cn/dasviewer"
        },
        {
          name: "网格大师",
          describe: "实景三维数据治理专家",
          link: "进一步了解>",
          url: "/static/images_20230306/首页/grid.webp",
          router: "/cn/dasmesh"
        },
        {
          name: "模方",
          describe: "实景三维的PhotoShop",
          link: "进一步了解>",
          url: "/static/images_20230306/首页/cube.webp",
          router: "/cn/mofang"
        },
        {
          name: "定拍DShot",
          describe: "便携式空间影像采集仪",
          link: "进一步了解>",
          url: "/static/images_20230306/首页/DShot.webp",
          router: "/cn/dshot"
        }
      ],
      dataImg: [
        "/static/images_20230306/首页/scene.webp",
        "/static/images_20230306/首页/substance.webp",
        "/static/images_20230306/首页/CIM.webp"
      ],
      mySwiper: null,
      isActiveTab: 0,

      solveList: [
        {
          name: "CIM与CIM+",
          describe:
            "打造数字孪生城市底板，建设城市大脑中枢，全面支撑新型智慧城市建设。",
          link: "进一步了解>",
          url: "/static/images_20230306/首页/CIM_solve.webp",
          router: "/cn/cim"
        },
        {
          name: "元宇宙数字生命",
          describe: "在未来的元宇宙世界中， 人类通过数字化身，将得到永生。",
          link: "进一步了解>",
          url: "/static/images_20230306/首页/Meta_solve.webp",
          router: "/cn/meta"
        },
        {
          name: "自然资源监管",
          describe:
            "地上地下一体化三维信息技术，改造传统信息化流程与架构，提升信息化水平，为自然资源业务赋能。",
          link: "进一步了解>",
          url: "/static/images_20230306/首页/natural_solve.webp",
          router: "/cn/natural"
        },
        {
          name: "乡村振兴",
          describe: "实景三维赋能乡村治理、产业振兴， 用信息化技术惠民。",
          link: "进一步了解>",
          url: "/static/images_20230306/首页/village_solve.webp",
          router: "/cn/village"
        }
      ],
      morePaths: [
        "https://mp.weixin.qq.com/s/THfYO4eWUVNiw2FYsPYZmw",
        "https://mp.weixin.qq.com/s/6XrMbetKYMCqPgce0aLbwA",
        "https://mp.weixin.qq.com/s/wr5pxMJ3dOegiOjzDyz1lA",
        "https://mp.weixin.qq.com/s/Umliz5v70XDr7ZYWeuMhkw"
      ],
      newsUrl: "https://daspatial.com/cn/news",
      newsCards: [
        // 第一轮
        {
          url: "/static/images_20240311/news/19.jpg",
          name: "湖北省博物馆举办人工智能应用研讨活动",
          path: "https://mp.weixin.qq.com/s/N3asnIZ17QTGdrSL9AuCuQ"
        },
        {
          url: "/static/images_20240311/news/74.jpg",
          name: "探元计划洛阳站｜超精建模助力石窟数字化保护与传承",
          path: "https://mp.weixin.qq.com/s/ktf9zu9nEnLp7LwBFQb36w"
        },
        {
          url: "/static/images_20240311/news/75.jpg",
          name: "大势智慧与西安市勘察测绘院达成战略合作",
          path: "https://mp.weixin.qq.com/s/H9t2lUGFhGGctxNfmgijhQ"
        },
        {
          url: "/static/images_20240311/news/76.jpg",
          name: "南非国家航天局及缅甸国防部一行莅临大势参观交流",
          path: "https://mp.weixin.qq.com/s/oFf52rqx_2TKybvkLCsixQ"
        },
        {
          url: "/static/images_20240311/news/77.jpg",
          name: "6·14 文化和自然遗产日 | 凝驻文明印记，活化历史基因",
          path: "https://mp.weixin.qq.com/s/OG-n6-_3IODKRvM9-khXNQ"
        },
        {
          url: "/static/images_20240311/news/68.jpg",
          name: "大势智慧获评湖北省制造业单项冠军企业",
          path: "https://mp.weixin.qq.com/s/Moddrg9nT4kd51DZfPtvuw"
        },
        {
          url: "/static/images_20240311/news/73.jpg",
          name: "DasViewer3.6全新推出“矢量贴地”功能！",
          path: "https://mp.weixin.qq.com/s/s3EIyRO_6d-aPt-zbPRO4g"
        },
        {
          url: "/static/images_20240311/news/9.jpg",
          name: "全网首发！重建农场2.0正式接入DeepSeek",
          path: "https://mp.weixin.qq.com/s/gbinWXNBfeJpY-atQZKK9w"
        },
        {
          url: "/static/images_20240311/news/15.jpg",
          name: "低空科技护航珞樱春色，技术引领助推广阔应用",
          path: "https://mp.weixin.qq.com/s/MQ9l9LoV9fyXM6jNzpZIFw"
        },
        {
          url: "/static/images_20240311/news/18.jpg",
          name: "突破：海量倾斜高斯OPGS Cesium高效渲染！",
          path: "https://mp.weixin.qq.com/s/x9RuxjRoV58N8sJscjM-nQ"
        },
        {
          url: "/static/images_20240311/news/67.jpg",
          name: "数字武当项目获首张湖北省三维模型数据知识产权证书！",
          path: "https://mp.weixin.qq.com/s/a_Wh3H-c5AO6Kq4ubiFZSw"
        },
        {
          url: "/static/images_20240311/news/12.jpg",
          name: "重建大师卫星版功能升级，开创模型优化效能新高度",
          path: "https://mp.weixin.qq.com/s/niGeil_ULZ5jhENdsYOs-g"
        },
        // 第二轮
        {
          url: "/static/images_20240311/news/19.jpg",
          name: "湖北省博物馆举办人工智能应用研讨活动",
          path: "https://mp.weixin.qq.com/s/N3asnIZ17QTGdrSL9AuCuQ"
        },
        {
          url: "/static/images_20240311/news/74.jpg",
          name: "探元计划洛阳站｜超精建模助力石窟数字化保护与传承",
          path: "https://mp.weixin.qq.com/s/ktf9zu9nEnLp7LwBFQb36w"
        },
        {
          url: "/static/images_20240311/news/75.jpg",
          name: "大势智慧与西安市勘察测绘院达成战略合作",
          path: "https://mp.weixin.qq.com/s/H9t2lUGFhGGctxNfmgijhQ"
        },
        {
          url: "/static/images_20240311/news/76.jpg",
          name: "南非国家航天局及缅甸国防部一行莅临大势参观交流",
          path: "https://mp.weixin.qq.com/s/oFf52rqx_2TKybvkLCsixQ"
        },
        {
          url: "/static/images_20240311/news/77.jpg",
          name: "6·14 文化和自然遗产日 | 凝驻文明印记，活化历史基因",
          path: "https://mp.weixin.qq.com/s/OG-n6-_3IODKRvM9-khXNQ"
        },
        {
          url: "/static/images_20240311/news/68.jpg",
          name: "大势智慧获评湖北省制造业单项冠军企业",
          path: "https://mp.weixin.qq.com/s/Moddrg9nT4kd51DZfPtvuw"
        },
        {
          url: "/static/images_20240311/news/73.jpg",
          name: "DasViewer3.6全新推出“矢量贴地”功能！",
          path: "https://mp.weixin.qq.com/s/s3EIyRO_6d-aPt-zbPRO4g"
        },
        {
          url: "/static/images_20240311/news/9.jpg",
          name: "全网首发！重建农场2.0正式接入DeepSeek",
          path: "https://mp.weixin.qq.com/s/gbinWXNBfeJpY-atQZKK9w"
        },
        {
          url: "/static/images_20240311/news/15.jpg",
          name: "低空科技护航珞樱春色，技术引领助推广阔应用",
          path: "https://mp.weixin.qq.com/s/MQ9l9LoV9fyXM6jNzpZIFw"
        },
        {
          url: "/static/images_20240311/news/18.jpg",
          name: "突破：海量倾斜高斯OPGS Cesium高效渲染！",
          path: "https://mp.weixin.qq.com/s/x9RuxjRoV58N8sJscjM-nQ"
        },
        {
          url: "/static/images_20240311/news/67.jpg",
          name: "数字武当项目获首张湖北省三维模型数据知识产权证书！",
          path: "https://mp.weixin.qq.com/s/a_Wh3H-c5AO6Kq4ubiFZSw"
        },
        {
          url: "/static/images_20240311/news/12.jpg",
          name: "重建大师卫星版功能升级，开创模型优化效能新高度",
          path: "https://mp.weixin.qq.com/s/niGeil_ULZ5jhENdsYOs-g"
        }
      ],
      tabsHeadList: ["自然资源监管", "矿山监管", "农房核查解决方案"],
      tabActive: 0,
      tabsHeight: 0,
      multiple: null,
      newsTab: 0,
      earthList: [],
      filterEarthList: [],
      activeSide: 0,
      carouselHeight: "960px",
      mySwiper2: null,
      loading: false
    };
  },
  mounted() {
    let than = this;
    setTimeout(() => {
      $(".swiper-wrapper .t3").click(function() {
        let id = $(this).attr("data-id");
        if (id == 1) than.$router.push("/cn/nrs");
        else if (id == 2) than.$router.push("/cn/farmhouse");
        else if (id == 3) than.$router.push("/cn/mine");
      });
    }, 300);

    window.addEventListener("resize", () => this.resizeHeight());
    this.carouselHeight = (window.innerWidth / 1920) * 960 + "px";
    // this.initInterval();
    this.mySwiper = new Swiper(".swiper-container", {
      slidesPerView: 3,
      spaceBetween: 0,
      centeredSlides: true,
      centeredSlidesBounds: true,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });

    this.mySwiper2 = new Swiper(".swiper-container2", {
      slidesPerView: 3,
      spaceBetween: 0,
      centeredSlides: true,
      centeredSlidesBounds: true,
      parallax: true,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });
    this.getList();
  },
  destroyed() {
    window.removeEventListener("resize", () => this.resizeHeight());
  },
  methods: {
    routerPush(path) {
      this.$router.push(path);
    },
    windowOpen(url) {
      window.open(url);
    },
    gotoMore(item) {
      window.open(item.path);
    },
    gotoProduct(item) {
      if (item.path) {
        this.$router.push(item.path);
      } else if (item.pathlink) {
        window.open(item.pathlink);
      }
    },
    selectSide(val) {
      this.activeSide = val;
      if (this.multiple == 5) {
        if (val == 1) {
          this.filterEarthList = this.earthList.slice(10, 20);
        } else {
          this.filterEarthList = this.earthList.slice(0, 10);
        }
      } else {
        if (val == 1) {
          this.filterEarthList = this.earthList.slice(8, 16);
        } else {
          this.filterEarthList = this.earthList.slice(0, 8);
        }
      }
    },
    newsToPrev() {
      // this.$refs.newsRef;
      // if (this.newsTab === 8) this.newsTab = 0;
      // this.newsTab++;
      if (this.newsTab == 0) this.newsTab = 8;
      this.newsTab--;
      this.$refs.newsRef.style.transform = `translateX(-${this.newsTab *
        445}px)`;
    },
    newsToNext() {
      // if (this.newsTab == 0) this.newsTab = 8;
      // this.newsTab--;
      if (this.newsTab === 8) this.newsTab = 0;
      this.newsTab++;
      this.$refs.newsRef.style.transform = `translateX(-${this.newsTab *
        445}px)`;
    },
    avatarBtn(id) {
      this.$router.push("/userInfo?userId=" + id);
    },
    addRebuild() {
      window.open("https://www.get3d.cn/");
    },
    selectTab(val) {
      this.tabActive = val;
      this.tabsHeight = val * 254;
      if (val == 2) this.tabsHeight = 524;
      this.mySwiper2.slideToLoop(val, 1000, false);
    },
    resizeHeight() {
      this.getList();
      if (window.innerWidth < 1200) {
        return;
      }

      this.carouselHeight = (window.innerWidth / 1920) * 960 + "px";
    },
    carouselChange(value) {
      if ($(".active-picture"))
        $(".picture-content").removeClass("active-picture");
      this.active = value;
      setTimeout(() => {
        if ([2, 3, 4, 5].includes(value))
          $(".picture-content").addClass("active-picture");
      }, 600);
      this.active1 = 0;
    },
    toPrev() {
      this.$refs.myCarousel.prev();
    },
    toNext() {
      this.$refs.myCarousel.next();
    },
    setCarousel(val) {
      this.isActiveTab = val;
      this.mySwiper.slideToLoop(val, 1000, false);
    },
    initInterval() {
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.active1++;
        if (this.active1 >= 16) {
          this.$refs.myCarousel.next();
        }
      }, 400);
    },
    slideChange(n) {
      if (n == 1) {
        //上一个
        this.mySwiper.slidePrev(1000);
      } else {
        //下一个
        this.mySwiper.slideNext(1000);
      }
      this.isActiveTab = this.mySwiper.realIndex;
    },
    slideChange2(n) {
      if (n == 1) {
        //上一个
        this.mySwiper2.slidePrev(1000);
      } else {
        //下一个
        this.mySwiper2.slideNext(1000);
      }
      this.tabActive = this.mySwiper2.realIndex;
      this.tabsHeight = this.mySwiper2.realIndex * 254;
      if (this.mySwiper2.realIndex == 2) this.tabsHeight = 524;
    },

    getList() {
      let params = {
        owner: false,
        column: "recommend_time",
        page: 1,
        size: 20,
        recommend: true,
        asc: false,
        permission: "PUBLIC",
        status: "COMPLETED",
        name: ""
      };
      this.loading = true;
      modelApi
        .getRecommendNewList(params)
        .then(r => {
          this.loading = false;
          this.earthList = r.data.data.contents.slice(0, 20);
          if ($(window).width() > 1696) {
            this.multiple = 5;
            this.filterEarthList = this.earthList.slice(0, 10);
          } else {
            this.multiple = 4;
            this.filterEarthList = this.earthList.slice(0, 8);
          }
        })
        .catch(e => {});
    }
  }
};
</script>
<style scoped lang="scss">
@media screen and (max-width: 1200px) {
  .one_lbt_item_3 .one_lbt_item_40 {
    font-size: 22.5px;
  }

  .picture-title .picture-title-name {
    font-size: 22.5px;
  }

  .info_contain .info_contain_name {
    font-size: 22.5px;
  }

  .info_contain .info_contain_desc {
    font-size: 18px;
  }

  .one_lbt_item_60 img {
    width: 290px;
  }

  .picture-title-img img {
    width: 290px;
  }
}

.top-banner-video .tip {
  position: absolute;
  left: calc(((100% - 864px) / 2));
  top: 446px;
  width: 864px;
  height: 48px;
  opacity: 1;

  font-family: HarmonyOS Sans SC;
  font-size: 48px;
  font-weight: bold;
  line-height: 48px;
  text-align: center;
  display: flex;
  align-items: center;
  letter-spacing: 48px;

  /* Font/Font Wh/font Wh 90% */
  color: rgba(255, 255, 255, 0.9);

  text-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
}

.top-banner-picture {
  position: relative;

  .picture-content {
    position: absolute;
    top: calc(79.48% - 172px);
    // transform: translateX(100%);
    color: transparent;
    display: flex;
    flex-direction: column;
    padding-left: 125px;
    justify-content: center;
    width: 100%;
    height: 0px;
    background: linear-gradient(
      90deg,
      #1472e2 0%,
      rgba(20, 114, 226, 0.1) 100%
    );

    .picture-header {
      font-size: 40px;
      font-weight: bold;
    }

    .picture-desc {
      font-size: 28px;
      font-weight: 400;
      line-height: 56px;
    }

    .picture-link {
      font-size: 20px;
      margin-left: 33px;
    }
  }

  .active-picture {
    transition: all 0.5s linear;
    height: 172px;
    color: white;
    // transform: translateX(0%);
  }
}

.museum_tip {
  position: absolute;
  left: calc(((100% - 672px) / 2));
  top: calc(50% - 35px);
  width: 672px;
  height: 48px;
  opacity: 1;

  font-family: HarmonyOS Sans SC;
  font-size: 48px;
  font-weight: bold;
  line-height: 48px;
  text-align: center;
  display: flex;
  align-items: center;
  letter-spacing: 48px;

  /* Font/Font Wh/font Wh 90% */
  color: rgba(255, 255, 255, 0.9);

  text-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
}

.cp {
  cursor: pointer;
}

.one_next {
  position: absolute;
  top: calc(var(--carouselHeight) / 2);
  width: 60px;
  height: 61px;
  padding-top: 39px;
  /* line-height: 100px; */
  margin-top: -50px;
  background: rgba(0, 0, 0, 0);
  z-index: 10;
  transition: all 0.8s;
}

.is_active_next {
  background: rgba(0, 0, 0, 0.8);
}

.one_left_next {
  left: 0;
  border-radius: 0px 10px 10px 0px;
}

.one_left_next img {
  margin-left: 30px;
}

.one_right_next img {
  margin-left: 20px;
}

.one_right_next {
  right: 0;
  border-radius: 10px 0px 0px 10px;
}

.one_lbt_item_3 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 18.75%;
  /* width: 1200px; */
  cursor: pointer;

  display: flex;
  flex-direction: column;
}

.one_lbt_item_3 div {
  text-align: center;
  cursor: pointer;
}

.one_lbt_item_60 {
  /* font-size: 50px; */
  color: #ffffff;
  opacity: 1;
  width: 17.5vw;
  min-width: 209px;
}

.one_lbt_item_60 img {
  width: 100%;
}

.one_lbt_item_60.active {
  transform: none;
  opacity: 1;
  transition: opacity 0.6s linear,
    transform 0.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.one_lbt_item_40 {
  font-size: 36px;
  font-weight: 400;
  line-height: 44px;
  color: #000000;
  opacity: 1;
  font-size: 1.875vw;
}

.one_lbt_item_40.active {
  transform: none;
  opacity: 1;
  transition: opacity 0.6s linear,
    transform 0.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.picture-title {
  position: absolute;
  top: 17.7%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 26.25vw;
  min-width: 315px;
}

.picture-title-img {
  width: 66.5%;
}

.picture-title-img img {
  width: 100%;
  vertical-align: middle;
}

.picture-title-name {
  width: 504px;
  height: 46.93px;
  opacity: 1;

  /* 一级文字/常规 */
  font-family: HarmonyOS Sans SC;
  font-size: 1.875vw;
  font-weight: normal;
  line-height: 44px;
  text-align: center;
  letter-spacing: 0px;
  color: #3d3d3d;
}

.picture-title-link {
  text-align: center;
  border-radius: 95px;
  background-color: #5abfb9;
  gap: 10px;
  width: 128px;
  padding: 8px 24px;
  gap: 10px;
  font-family: HarmonyOS Sans SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0px;
  margin-top: 25px;
  color: rgba(255, 255, 255, 0.9);
}

.picture-title-link:hover {
  text-decoration: underline;
}

.font-color {
  color: #f5f7fa;
}

.farm-color {
  background-color: #a196c3;
}

.earth-color {
  display: block;
  background-color: #00adee;
}

.achieve-content {
  display: flex;
  color: transparent;

  .left-col {
    flex: 1;
    position: relative;
    margin-right: 10px;

    .left-header {
      position: absolute;
      font-size: 40px;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
      transition: all 0.5s;
      display: flex;
      flex-direction: column;
      justify-content: end;

      .header-title {
        padding-left: 37px;
        font-size: 32px;
        font-weight: 600;
        line-height: 38px;

        @media screen and (max-width: 1440px) {
          font-size: 20px;
          padding-left: 25px;
          line-height: 25px;
        }
      }

      .header-desc {
        font-size: 32px;
        font-weight: 400;
        padding-left: 37px;
        padding-bottom: 36px;
        line-height: 38px;

        @media screen and (max-width: 1440px) {
          font-size: 20px;
          padding-left: 25px;
          padding-bottom: 25px;
          line-height: 25px;
        }
      }

      // div {
      //   transform: translate(37px, 540px);
      // }
    }

    .achieve-img {
      width: 100%;
      height: 100%;
    }

    .left-header:hover {
      background: rgba(0, 0, 0, 0.4);
      // ;
    }
  }

  .left-col:hover {
    color: #ffffff;
  }

  .right-col {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 10px;

    .top-content {
      margin-bottom: 7px;
      position: relative;

      .top-header {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        transition: all 0.5s;
        display: flex;
        flex-direction: column;
        justify-content: end;

        // div {
        //   transform: translate(30px, 224px);
        // }

        .header-title {
          font-size: 20px;
          font-weight: 700;
          padding-left: 30px;
          line-height: 25px;

          @media screen and (max-width: 1440px) {
            font-size: 16px;
            padding-left: 25px;
            line-height: 20px;
          }
        }

        .header-desc {
          font-size: 20px;
          font-weight: 400;
          padding-left: 30px;
          padding-bottom: 30px;

          @media screen and (max-width: 1440px) {
            font-size: 16px;
            padding-left: 25px;
            padding-bottom: 25px;
            line-height: 20px;
          }
        }

        .font-small {
          font-size: 18px;
          padding-left: 29px;
          font-weight: 400;

          @media screen and (max-width: 1200px) {
            // font-size: 20px;
          }
        }
      }

      .achieve-img {
        width: 100%;
        height: 100%;
      }

      // .top-header-overlay {
      //   position: absolute;
      //   width: 100%;
      //   height: 100%;
      //   top: 0;
      //   left: 0;
      // }

      .top-header:hover {
        background: rgba(0, 0, 0, 0.4);
        // ;
      }
    }

    .top-content:hover {
      color: #ffffff;
    }

    .bottom-content {
      display: flex;
      margin-top: 10px;

      .bottom-left {
        margin-right: 10px;
        position: relative;
        width: 50%;

        .bottom-left-header {
          position: absolute;
          left: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
          transition: all 0.5s;
          display: flex;
          flex-direction: column;
          justify-content: end;

          // div {
          //   transform: translate(30px, 220px);
          // }

          // z-index: 1;
          .header-title {
            font-size: 20px;
            font-weight: 700;
            padding-left: 30px;
            line-height: 25px;

            @media screen and (max-width: 1440px) {
              font-size: 16px;
              padding-left: 25px;
              line-height: 20px;
            }
          }

          .header-desc {
            font-size: 20px;
            font-weight: 400;
            padding-left: 30px;
            padding-bottom: 30px;

            @media screen and (max-width: 1440px) {
              font-size: 16px;
              padding-left: 25px;
              padding-bottom: 25px;
              line-height: 20px;
            }
          }
        }

        .achieve-img {
          width: 100%;
          height: 100%;
        }

        // .bottom-left-overlay {
        //   position: absolute;
        //   width: 100%;
        //   height: 100%;
        //   top: 0;
        //   left: 0;
        // }

        .bottom-left-header:hover {
          background: rgba(0, 0, 0, 0.4);
          // ;
        }
      }

      .bottom-left:hover {
        color: #ffffff;
      }

      .bottom-right {
        margin-left: 10px;
        position: relative;
        width: 50%;

        .bottom-right-header {
          position: absolute;
          left: 0px;
          bottom: 0px;
          width: 100%;
          height: 100%;
          transition: all 0.5s;
          flex-direction: column;
          justify-content: end;
          display: flex;

          // z-index: 1;
          .header-title {
            font-size: 20px;
            font-weight: 700;
            padding-left: 30px;
            line-height: 25px;

            @media screen and (max-width: 1440px) {
              font-size: 16px;
              padding-left: 25px;
              line-height: 20px;
            }
          }

          .header-desc {
            font-size: 20px;
            font-weight: 400;
            padding-left: 30px;
            padding-bottom: 30px;

            @media screen and (max-width: 1440px) {
              font-size: 16px;
              padding-left: 25px;
              padding-bottom: 25px;
              line-height: 20px;
            }
          }
        }

        .achieve-img {
          width: 100%;
          height: 100%;
        }

        // .bottom-right-overlay {
        //   position: absolute;
        //   width: 100%;
        //   height: 100%;
        //   top: 0;
        //   left: 0;
        // }

        .bottom-right-header:hover {
          background: rgba(0, 0, 0, 0.4);
          // ;
        }
      }

      .bottom-right:hover {
        color: #ffffff;
      }
    }
  }
}

.row-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  text-align: center;
  justify-content: space-between;
}

.swiper_content {
  position: relative;
  height: 720px;
}

.swiper-slide {
  display: flex;
  text-align: center;
  font-size: 18px;
  margin: 10px;
  /* background: #fff; */
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(1);
}

.swiper_slide_img {
  display: flex;
  /* padding: 10px; */
  /* background-color: #ffffff; */
}

.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}

.data_header {
  display: flex;
  justify-content: center;
  font-size: 48px;
  font-weight: bold;
  text-align: center;
  margin-top: 100px;
}

.data_desc {
  display: flex;
  justify-content: center;
  font-size: 20px;
  margin-top: 15px;
}

.data_tab {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px auto;
  width: 1200px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.26);
}

.tab_item {
  // width: 112px;
  height: 40px;
  // border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0px;
  box-sizing: border-box;
  // border: 1px solid rgba(0, 0, 0, 0.9);
}

.mid-tab-item {
  margin-left: 163px;
  margin-right: 186px;
}

// .tab_item:hover {
//   color: #1472e2;
//   border: 1px solid #1472e2;
// }

.img_gap {
  margin: 0 50px;
}

.lbt_l,
.lbt_r {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  width: 50px;
  height: 50px;
  // background-color: #fff;
  // border-radius: 50%;
  z-index: 99;
  transform: translateY(-50%);
}

.lbt_l {
  // left: 20px;
  left: calc(((100% - 1200px) / 2) + 64px);
}

.lbt_r {
  // right: 20px;
  right: calc(((100% - 1200px) / 2) + 64px);
}

.tab_item_active {
  color: #1472e2;
  border-bottom: 2px solid #1472e2;
}

.solve_content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 30px;
  padding: 10px;
}

.text_content {
  position: absolute;
  text-align: center;
}

.row-left {
  left: 50%;
  transform: translateX(-50%);
}

.row-right {
  left: 50%;
  transform: translateX(-50%);
}

.solve_card {
  display: flex;
  width: 50%;
  position: relative;
}

.solve_card_name {
  font-size: 36px;
  margin-top: 50px;
  font-weight: bold;
}

.solve_card_desc {
  width: 400px;
  font-size: 20px;
  font-weight: normal;
  line-height: 28px;
  letter-spacing: 0px;
}

.solve_card_link {
  font-size: 16px;
  color: #1472e2;
  cursor: pointer;
}

.cloud_earth {
  margin-top: 100px;
}

.earth_header {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  font-weight: bold;
  line-height: 62px;
  text-align: center;
}

.earth_desc {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin: 15px 0 30px 0;
}

.earth_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  // font-size: 20px;
  margin: auto;
  padding-bottom: 52px;
}

.card-box {
  margin: 0 50px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: flex-start;
}

.earth_bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  // font-size: 20px;
  margin: auto;
  padding-bottom: 110px;

  .left-btn,
  .right-btn {
    width: 60px;
    height: 5px;
    background: #1e6fff;
    opacity: 0.1;
    margin: 4px;
  }

  .active-btn {
    opacity: 1;
  }
}

.earth_slide {
  /* 写相对定位是因为一会轮播图上的小圆点需要做绝对定位 */
  position: relative;
  /* 让轮播图在页面中居中 */
  margin: auto;
  /* 宽度和高度就是一张图的宽和高 */
  width: 100%;
  height: 750px;
  /* 只显示一张图，其他超出盒子的图片先隐藏掉 */
  overflow: hidden;
}

.left_earth_swiper {
  list-style: none;
  /* 宽度尽量写大，确保能放下所有的图片 */
  width: 4064px;
  /* width: 5588px; */

  /* 控制ul开始做位置移动（利用css动画特性来实现===核心代码） */
  animation: swiperLeftRun 20s linear infinite;
  position: absolute;
}

.left_earth_swiper li {
  width: 234px;
  height: 291px;
  margin: 0 10px;
  float: left;
}

.right_earth_swiper {
  list-style: none;
  /* 宽度尽量写大，确保能放下所有的图片 */
  width: 4064px;
  /* 控制ul开始做位置移动（利用css动画特性来实现===核心代码） */
  animation: swiperRightRun 20s linear infinite;
  position: absolute;
  top: 350px;
  right: 0px;
}

.right_earth_swiper li {
  width: 234px;
  height: 291px;
  margin: 0 10px;
  float: right;
}

.left_earth_swiper:hover {
  animation-play-state: paused;
}

.right_earth_swiper:hover {
  animation-play-state: paused;
}

@keyframes swiperLeftRun {
  0% {
    transform: translateX(0px);
  }

  100% {
    transform: translateX(-2032px);
  }
}

@keyframes swiperRightRun {
  0% {
    transform: translateX(0px);
  }

  100% {
    transform: translateX(2032px);
  }
}

.partner-contain {
  text-align: center;
  margin: 0 auto;
  padding-top: 37px;
}

.partner-title {
  font-size: 48px;
  font-weight: bold;
  line-height: 62px;
  text-align: center;
  letter-spacing: 0em;
  margin-bottom: 28px;
}

.swiper-tabs {
  border-bottom: 1px solid rgba(0, 0, 0, 0.26);
  width: 1200px;
  height: 35px;
  margin: auto;
  margin-top: 20px;
}

.tabs-head {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 16px;
  font-weight: normal;
  color: #000000;
  height: 35px;
}

.tabs-scroll {
  position: absolute;
  width: 125px;
  height: 2px;
  background-color: #1472e1;
  transform: translate(var(--moveX), 18px);
  transition: transform 0.3s cubic-bezier(0.65, 0.05, 0.36, 1);
}

.tabs-head-item {
  width: 33.33%;
  height: 35px;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.tab-active {
  color: #1472e1;
}

.solve_plan {
  .swiper_content2 {
    /* height: 718px; */
    margin-top: 39px;

    .lbt_r,
    .lbt_l {
      background-color: transparent;
      width: 40px;
      height: 40px;
    }

    .lbt_l {
      left: calc(((100% - 1200px) / 2) + 64px);
    }

    .lbt_r {
      right: calc(((100% - 1200px) / 2) + 64px);
    }

    .swiper-container2 .swiper-slide {
      transform: scale(1);
      height: 718px;
    }
  }
}

.programme_box .t1 {
  font-size: 36px;
  font-weight: bold;
  height: 42px;
  line-height: 42px;
  margin: 84px 0 12px;
}

.t2 {
  font-size: 20px;
  margin: 0 auto 10px;
  text-align: left;
  color: #1a1a1a;
  line-height: 23px;
  letter-spacing: 0px;
  text-align: center;
}

.t3 {
  font-size: 16px;
  height: 19px;
  line-height: 19px;
  color: #1472e1;
  cursor: pointer;
}

.news-dynamic {
  display: flex;
  width: 100%;
  height: 375px;
  // background-image: url("/static/images_20230726/new/0.webp");
  // background-position: center;
  // background-size: cover;

  .news-desc {
    position: relative;
    width: 425px;
    height: 100%;
    z-index: 2;

    .news-desc-container {
      display: flex;
      flex-direction: column;
      // color: #fff;
      justify-content: center;
      // align-items: center;
      width: 100%;
      height: 100%;
      background: rgb(245, 245, 247);
      font-size: 48px;
      line-height: 48px;
      position: absolute;
      top: 0px;
      left: 0px;

      .news-desc-head {
        padding-left: 25%;
        letter-spacing: 0;
        z-index: 3;
      }

      .news-desc-content {
        padding-left: 25%;
        font-weight: bold;
        letter-spacing: 0em;
        z-index: 3;
      }

      .news-more {
        color: #1472e2;
        font-size: 16px;
        position: absolute;
        left: 25%;
        bottom: 0;
        z-index: 3;
        cursor: pointer;
      }
    }

    .back {
      background-image: url("/static/images_20230726/new/0.webp");
      background-size: cover;
      background-position: left;
      width: 100%;
      height: 100%;
      z-index: 2;
      position: relative;
    }
  }

  .news-container {
    width: calc(100% - 425px);
    overflow: hidden;
    display: flex;
    position: relative;

    .news-left-btn {
      left: 10px;
    }

    .news-right-btn {
      right: 0px;
    }

    .news-btn {
      position: absolute;
      // left: 10px;
      top: calc(50% - 20px);
      display: flex;
      justify-content: center;
      align-items: center;
      // background: #212121;
      z-index: 2;
      width: 20px;
      padding: 10px;
      border-radius: 5px;
    }

    .news-btn:hover {
      background: rgba(0, 0, 0, 0.8);
    }

    .news-content {
      display: flex;
      flex: 1 1 0;
      margin: auto;
      // transition: all 0.5s;
      animation: newSwiperLeftRun 60s linear infinite;

      .news-card {
        position: relative;
        width: 425px;
        height: 260px;
        margin: 0 10px;
        display: flex;
        align-items: center;

        .news-card-desc {
          position: absolute;
          display: flex;
          flex-direction: column;
          left: 0px;
          top: 230px;
          font-size: 16px;
          letter-spacing: 0rem;
          color: #535353;
          // text-align: center;
          justify-content: center;
          width: 100%;
          // height: 100%;

          .news-card-name {
            cursor: pointer;
            white-space: nowrap;

            img {
              transform: translateY(4px);
            }
          }
        }

        .news-card-img {
          background-size: cover;
          background-position: center;
          width: 425px;
          height: 182px;
        }
      }
    }

    .news-content:hover {
      animation-play-state: paused;
    }
  }
}

.product-content {
  .row {
    display: flex;
    height: 500px;

    &.sp {
      height: 640px;

      .card .info {
        padding-top: 50px;
      }
    }

    .card {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;

      &:hover {
        img {
          transform: scale(1.1);
          transform-origin: center center;
        }
      }

      .info {
        padding: 172px 0 0 82px;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        text-align: left;

        > div {
          &:nth-child(1) {
            font-size: 40px;
            font-weight: 700;
            line-height: 46.88px;
            letter-spacing: -0.03em;
          }
          &:nth-child(2) {
            font-size: 20px;
            line-height: 23.44px;
            margin-top: 15px;
            color: #5c5c5c;
          }
          &:nth-child(3) {
            width: 96px;
            height: 36px;
            text-align: center;
            line-height: 34px;
            background-color: #212121;
            color: white;
            cursor: pointer;
            margin-top: 30px;

            &:hover {
              background-color: #1472e2;
            }
          }
        }
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.4s ease;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .data_header,
  .earth_header,
  .partner-title {
    font-size: 36px;
    font-weight: 700;
    line-height: 42.19px;
    letter-spacing: 0.02em;
  }
  .product-content {
    .row {
      height: 376px;

      &.sp {
        height: 487px;

        .card .info {
          padding-top: 37px;
        }
      }

      .card {
        .info {
          padding: 130px 0 0 61px;

          > div {
            &:nth-child(1) {
              font-size: 32px;
              font-weight: 700;
              line-height: 37.5px;
              letter-spacing: -0.03em;
            }
            &:nth-child(2) {
              font-size: 16px;
              font-weight: 400;
              line-height: 18.75px;
              margin-top: 8px;
            }
            &:nth-child(3) {
              width: 72px;
              height: 27px;
              line-height: 25px;
              margin-top: 21px;
              font-size: 10px;
            }
          }
        }
      }
    }
  }
  .data_desc,
  .earth_desc {
    font-size: 16px;
    font-weight: 400;
    line-height: 18.75px;
    margin-top: 10px;
  }
  .news-dynamic {
    height: 260px;

    .news-desc {
      width: 302px;

      .news-desc-container {
        font-size: 36px;
        line-height: 42.19px;

        .news-more {
          font-size: 12px;
          font-weight: 400;
          line-height: 14.06px;
        }

        .news-more {
          bottom: 10px;
        }
      }
    }

    .news-container {
      width: calc(100% - 302px);

      .news-content {
        .news-card {
          width: 319px;
          height: 137px;

          .news-card-img {
            width: 319px;
            height: 137px;
          }

          .news-card-desc {
            top: 144px;
            font-size: 12px;
            font-weight: 400;
            line-height: 14.06px;

            img {
              height: 14px;
            }
          }
        }
      }
    }
  }
  .programme_box {
    .t1 {
      font-size: 24px;
      font-weight: 700;
      line-height: 28.13px;
      margin-top: 53px;
      height: 24px;
    }

    .t2 {
      font-size: 14px;
      font-weight: 400;
    }

    .t3 {
      font-size: 12px;
      font-weight: 400;
      line-height: 14.06px;
    }
  }
  .swiper_content {
    height: 540px !important;

    .swiper-container,
    .swiper-container2 {
      width: 2700px !important;
      height: 540px !important;
      left: 50% !important;

      .swiper-slide {
        width: 900px !important;
        height: 540px !important;

        .swiper_slide_img {
          .img {
            width: 900px !important;
            height: 540px !important;
          }
        }
      }
    }
  }
  .lbt_l {
    left: calc(((100% - 900px) / 2) + 64px) !important;
  }
  .lbt_r {
    right: calc(((100% - 900px) / 2) + 64px) !important;
  }
  .partner-contain {
    img {
      width: 908px;
    }
  }
}

@keyframes newSwiperLeftRun {
  0% {
    transform: translateX(-445px);
  }

  100% {
    transform: translateX(-5785px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cn/home/index.vue